import apiUrl, { urlToKey } from './apiUrl'
import errMsg from './errMsg'

export const ResType = {
  0: '综合',
  1: '公告',
  2: '活动',
  3: '攻略',
  4: '游戏介绍',
  5: '角色介绍',
  6: '轮播图',
  7: '游戏截图'
}

export const CollectionType = {
  game: 1,
  act: 2
}

export const GameFlag = {
  open: '开启',
  close: '关闭',
  new: '新开',
  hot: '火爆',
  maintain: '维护'
}

export const statData = {
  pro: 'xl_web',
  channel: 'XLQD',
  channel_desc: '迅雷渠道'
}

export default {
  apiUrl,
  urlToKey,
  errMsg,
  CollectionType,
  ResType,
  statData
}
